<template>
  <div class="animated fadeIn">
    <CModal
      :show.sync="showModal"
      color="danger"
      accent-color="danger"
      >
      <template #header>
        <h5 class="modal-title">{{ title }}</h5>
        <CButtonClose @click="$emit('cancelled',false)" class="text-white"/>
      </template>

      <!-- <p v-if="isText">{{ content }}</p>
      <span v-else v-html="rawHtml"></span> -->

      <p v-if="content">{{ content }}</p>

      <slot></slot>

      <template #footer>
        <CButton @click="$emit('cancelled',false);  groupId = null" color="outline-warning">Cancelar</CButton>
        <CButton @click="$emit('ok', true)" color="danger">Aceptar</CButton>
      </template>
    </CModal>

    <toast ref="toast"></toast>

  </div>

</template>

<script>
export default {
  name:'DeleteModal',
  props: {
    show: {type: Boolean, default: false },
    title: {type: String, default: 'Eliminar'},
    isText: {type: Boolean, default: true },
    content: {type: String},
    rawHtml: {type: String},
  },
  data() {
    return {

    }
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function (newValue) {
        this.$emit("update:show", newValue)
      }
    }
  },
  methods: {
    cancelled(){
      this.$emit('cancelled',false) ;
    },
  }


}
</script>
